export default __webpack_public_path__ + "static/media/Rank4Q.785d1eb1.png";